/**
 * A safe, human-readable message from any axios error.
 *
 * FastAPI returns `detail` as a string for our own AppServiceError raises, but
 * as an ARRAY of validation objects for Pydantic 422s. Handing that array
 * straight to a toast renders an object as a React child and takes the whole
 * page down, so every catch block funnels through here.
 */
export const apiErrorMessage = (error, fallback = 'Something went wrong') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => d?.msg).filter(Boolean);
    if (msgs.length) return msgs.join('; ');
  }
  if (detail && typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
};

export default apiErrorMessage;
